import React, { useState } from 'react';
import './ProjectCard.css';
import Button from '../UI/ModifiedButton';
import Modal from '../UI/Modal';
import { FaGithub, FaExternalLinkAlt } from 'react-icons/fa';

function ProjectCard(props) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleCardClick = (e) => {
    // Don't open modal if clicking on a button or link
    if (e.target.tagName !== 'A' && e.target.tagName !== 'BUTTON' && !e.target.closest('.project-card-actions')) {
      openModal();
    }
  };

  return (
    <>
      <div className='project-card' onClick={handleCardClick}>
        <div className="project-card-image-container">
          <img src={props.image} alt={props.heading}/>
          <div className="project-card-overlay">
            <h2 className='project-card-heading'>{props.heading}</h2>
          </div>
        </div>
        <div className="project-card-actions" onClick={(e) => e.stopPropagation()}>
          {props.codeLink && (
            <a href={props.codeLink} target='_blank' rel='noreferrer' className='action-link'>
              <Button><FaGithub /> Code</Button>
            </a>
          )}
          {props.demoLink && (
            <a href={props.demoLink} target='_blank' rel='noreferrer' className='action-link'>
              <Button><FaExternalLinkAlt /> Demo</Button>
            </a>
          )}
        </div>
      </div>

      {isModalOpen && (
        <Modal
          heading={props.heading}
          description={props.description}
          technologies={props.technologies}
          image={props.image}
          closeModal={closeModal}
          codeLink={props.codeLink}
          demoLink={props.demoLink}
        />
      )}
    </>
  )
}

export default ProjectCard
